export const validator = {
  validate: (formData) => {
    const errors = {};
    const warnings = {};

    const { business = {}, jobAddress = {}, heatPump = {}, groundLoop = {}, issuedBy = {} } = formData;

    if (!business.businessName?.trim()) {
      errors['business.businessName'] = 'Business name is required';
    }
    if (!jobAddress.jobName?.trim()) {
      errors['jobAddress.jobName'] = 'Customer / Job name is required';
    }
    if (!jobAddress.jobAddress?.trim()) {
      errors['jobAddress.jobAddress'] = 'Job address is required';
    }
    if (!heatPump.make?.trim()) {
      errors['heatPump.make'] = 'Heat pump make is required';
    }
    if (!heatPump.model?.trim()) {
      errors['heatPump.model'] = 'Heat pump model is required';
    }
    if (!heatPump.serialNumber?.trim()) {
      errors['heatPump.serialNumber'] = 'Serial number is required';
    }
    if (Number(groundLoop.brinePressureBar) < 1.0) {
      warnings['groundLoop.brinePressureBar'] = 'Brine loop pressure is low (< 1.0 Bar). Check for leaks or pre-charge.';
    }
    if (!issuedBy.engineerSignature) {
      errors['issuedBy.engineerSignature'] = 'Engineer signature is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
      warnings
    };
  }
};

export default validator;
